import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import sift from "sift";
import { sort } from "sift-sort";
import { str } from "dot-object";
import { lowercaseAndParseSpaces as _lowercaseAndParseSpaces } from "../utils";
export var generateBuilderSlug = _lowercaseAndParseSpaces;
export var lowercaseAndParseSpaces = _lowercaseAndParseSpaces;

var isArray = function isArray(a) {
  return Array.isArray(a);
};

export var queryBuilder = function queryBuilder(a, b) {
  var c = b || {},
      d = c.filters,
      e = c.statusOptions,
      f = void 0 === e ? [] : e,
      g = c.sort,
      h = _objectWithoutProperties(c, ["filters", "statusOptions", "sort"]);

  if (d) {
    console.log(d);
    var m = {
      $and: [],
      $or: [{
        status_id: 1
      }, {
        status: 1
      }, {
        status_id: 3
      }, {
        status: 3
      }, {
        status_id: 4
      }, {
        status: 4
      }, {
        $not: {
          propertyType: "apartment"
        },
        status: {
          $exists: !1
        }
      }]
    };
    f && f.length && (f.includes("promoted") && m.$and.push({
      promoted: 1
    }), f.includes("titled") && m.$and.push({
      flags: {
        titled: {
          $and: [{
            $exists: 1
          }, {
            $eq: 1
          }]
        }
      }
    })), Object.keys(d).map(function (a) {
      var b = h[a];

      if (b) {
        var l = d[a];
        if (!l) return null;
        var c = l || {},
            e = c.type,
            f = l.apiName || a; // some packages values have different name on the api
        // so each filter has a { apiName } field if needed

        if ("range" === e || "select" === e && !l.options) // if is array means is a range [from, to]
          if (isArray(b)) {
            var g = _slicedToArray(b, 2),
                i = g[0],
                j = g[1],
                k = i === l.from && j === l.to; // if the "to" value is greater or equal to the filter maximum allowed
            // and since the last value has a "+" sign, for example 5
            // then we filter all greater than the "from" value


            if (!k) if (i && !j || !i && j) {
              var n = ["price", "area", "frontage", "lot_area", "lot_frontage", "land_size"].includes(f);
              n ? (i && (m[f] = {
                $gte: i
              }), j && (m[f] = {
                $lte: j
              })) : m[f] = {
                $where: "this == '".concat(i || j, "'")
              };
            } else m[f] = j >= l.to ? {
              $gte: i
            } : {
              $gte: i,
              $lte: j
            };
          } else b >= l.to ? m[f] = {
            $gte: b
          } : m.$and.push(_defineProperty({}, f, b));
        "select" === e && l.options && (m[f] = {
          $in: isArray(b) ? b : [b]
        }), "check-list" === e && l.options && (m[f] = {
          $in: isArray(b) ? b : [b]
        });
      }

      return null;
    }), m.$and.length || delete m.$and, m.$or.length || delete m.$or, a = a.filter(sift(m));
  }

  if (g && "string" == typeof g) {
    var i = g.split("-"),
        j = _slicedToArray(i, 2),
        k = j[0],
        l = j[1];

    if (k) {
      var n = {};
      str(k, l ? -1 : 1, n), a = sort(a, n);
    }
  }

  return a;
};